import { KeyboardEventHandler } from 'react'

export const blockInvalidChar = (
  e: any
): KeyboardEventHandler<HTMLInputElement> =>
  ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()
